import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
    connect() {
        Turbo.visit(window.location.href, { action: "replace" });
    }
}
